export default {
    deviceName: "Device Name",
    deviceSN: "Device SN",
    addedRobotDog: "Added Robot Dog",
    editRobotDog: "Edit Robot Dog",
    online: "Online",
    offline: "Offline",
    standingMode: "Standing Mode",
    lockMode: "Lock Mode",
    enterMonitoring: "Enter monitoring",
    bindingCode: "Binding Code",
    name: "Name",
    lockedState: "Locked state",
    unlockedState: "Unlocked state",
    endStreaming: "End streaming",
    startStreaming: "Start streaming",
    emergencyStop: "Emergency Stop",
    lookUp: "Look Up",
    rotateLeft: "Rotate Left",
    bowYourHead: "Bow your head",
    rotateRight: "Rotate Right",
    goAhead: "Go Ahead",
    shiftLeft: "Shift Left",
    back: "Back",
    shiftRight: "Shift Right",
    pointCloudModeling: "Point cloud modeling",
    stopModeling: "Stop Modeling",
    startModeling: "Start Modeling",
    pointCloudDownload: "Point cloud download",
    stopCopying: "Stop copying",
    startCopying: "Start copying",
    returnToRobotDogList: "Return to robot dog list",
    getDown: "Get Down",
    stand: "Stand",
    mobileMode: "Mobile Mode",
    inPlaceMode: "In-place mode",
    bodyElevation: "Body Elevation",
    turnLeft: "Turn Left",
    bodyLowered: "Body Lowered",
    turnRight: "Turn Right",
    leftLeaning: "Left Leaning",
    rightLeaning: "Right Leaning",
    tip_PETDN: "Please enter the device name",
    tip_PETDS: "Please enter the device SN",
    tip_PETRDS: "Please enter the robot dog SN",
    tip_PETBC: "Please enter the binding code",
    tip_PETNO: "Please enter the name of the robot dog",
    tip_TRDIC: "The robot dog is currently locked. Click to unlock it.",
    tip_TRDICU: "The robot dog is currently unlocked. Click to lock it.",
    tip1: "Point cloud model is being generated, please move the robot dog",
    tip2: "Please insert the USB drive into the robot dog",
    tip3: "The robot dog is currently lying down. Click to stand up.",
    tip4: "The robot dog is currently standing, click to lie down",
    tip5: "The robot dog is currently in mobile mode. Click to switch to stationary mode.",
    tip6: "The current robot dog is in the stationary mode. Click to switch to the mobile mode.",
};